<template>
  <div class="flex flex-wrap -mx-4">
    <div class="w-full sm:w-1/3 px-4">
      <div class="sticky pin-t-4">
        <example-header
          title="Dynamic"
          :showing-code="showingCode"
          @toggle="toggleCode"
        />
        <div class="my-2">
          <p>
            Passing a <span class="font-bold">reactor</span> prop allows us to
            dynamically update the number and order of grid items.
          </p>
        </div>
        <div class="my-4">
          <button
            class="mr-1 text-sm border border-grey-dark text-grey-dark hover:bg-grey-dark hover:text-white font-bold py-1 px-2 "
            @click="addItem"
          >
            Add
          </button>
          <button
            class="mr-1 text-sm border border-grey-dark text-grey-dark hover:bg-grey-dark hover:text-white font-bold py-1 px-2 "
            @click="removeLastItem"
          >
            Remove
          </button>
          <button
            class="text-sm border border-grey-dark text-grey-dark hover:bg-grey-dark hover:text-white font-bold py-1 px-2 "
            @click="shuffleItems"
          >
            Shuffle
          </button>
        </div>
      </div>
    </div>
    <div class="w-full sm:w-2/3 px-4">
      <div v-if="showingCode">
        <pre class="p-4 text-sm bg-grey-lighter">
<code v-pre><span class="hl-tag">&lt;template&gt;</span>
  <span class="hl-tag">&lt;vue-packer :reactor=<span class="hl-string">&quot;items&quot;</span>&gt;</span>
    <span class="hl-comment">&lt;!-- Your components --&gt;</span>
    <span class="hl-tag">&lt;item-component 
      v-for=<span class="hl-string">&quot;item of items&quot;</span>
      :key=<span class="hl-string">&quot;item.id&quot;</span>
    /&gt;</span>
  <span class="hl-tag">&lt;/vue-packer&gt;</span>
<span class="hl-tag">&lt;/template&gt;</span>

<span class="hl-tag">&lt;style&gt;</span>
.packer-sizer {
  <span class="hl-keyword">width</span>: <span class="hl-number">33.333%</span>;
}
<span class="hl-tag">&lt;/style&gt;</span></code></pre>
      </div>
      <vue-packer v-else :reactor="items" base-class="ex-basic">
        <div
          v-for="{ id, height } of items"
          :key="id"
          class="ex-basic-item"
          :style="{ height }"
        >
          {{ id }}
        </div>
      </vue-packer>
    </div>
  </div>
</template>

<script>
import example from '@/mixins/example';

export default {
  mixins: [example],
  methods: {
    createItem() {
      this.count = this.count + 1;
      return {
        id: this.count,
        height: `${this.getRand(100, 200)}px`,
      };
    },
  },
};
</script>

<style lang="sass">
.ex-basic
  margin: -0.5rem -0.25rem

.ex-basic-sizer
  width: percentage(1/3)

.ex-basic-item
  display: flex
  align-items: center
  justify-content: center
  border: 1px solid #ccc
  padding: 0.5rem
  margin: 0.5rem 0.25rem
</style>
